import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UnassociatedTagsPage} from './unassociated-tags';
import {TranslateModule} from "@ngx-translate/core";
import {ComponentsModule} from "../../components/components.module";
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {DirectivesModule} from "../../directives/directives.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
   UnassociatedTagsPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    ComponentsModule,
    DirectivesModule,
    InfiniteScrollModule,
    IonicPageModule.forChild(UnassociatedTagsPage),
    TranslateModule.forChild()
  ],
})
export class UnassociatedTagsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/unassociated-tags/unassociated-tags.module.ts